"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReturnFromTraversalNonBaseMap = exports.isReturnFromTraversalBaseType = exports.isReturnFromTraversalBaseMap = void 0;
// Type guards
function isReturnFromTraversalBaseMap(traversalReturn) {
    if (isReturnFromTraversalBaseType(traversalReturn))
        return false;
    for (const value of traversalReturn.values()) {
        return isReturnFromTraversalBaseType(value);
    }
    return true; // in case it is empty, assume true
}
exports.isReturnFromTraversalBaseMap = isReturnFromTraversalBaseMap;
function isReturnFromTraversalBaseType(traversalReturn) {
    return !(traversalReturn instanceof Map);
}
exports.isReturnFromTraversalBaseType = isReturnFromTraversalBaseType;
function isReturnFromTraversalNonBaseMap(traversalReturn) {
    if (isReturnFromTraversalBaseType(traversalReturn))
        return false;
    for (const value of traversalReturn.values()) {
        return !isReturnFromTraversalBaseType(value);
    }
    return true; // in case it is empty, assume true
}
exports.isReturnFromTraversalNonBaseMap = isReturnFromTraversalNonBaseMap;
//# sourceMappingURL=types.js.map